import { MESApiService, type spParameter } from "@dexteel/mesf-core";
import type { Location } from "../models/CatLocation";

export const getLocations = async () => {
  const apiService = new MESApiService();

  return await apiService.callV2("[BYI].[GetCatLocations]", []);
};

export const upsertLocation = async (location: Location) => {
  const apiService = new MESApiService();

  const parameters: spParameter[] = [
    { name: "LocationId", value: location.LocationId },
    { name: "Name", value: location.Name },
    { name: "LocationDirectionType", value: location.LocationDirectionType },
    { name: "AddFillingType", value: location.AddFillingType },
    { name: "AddGrouped", value: location.AddGrouped },
    { name: "RemoveFillingType", value: location.RemoveFillingType },
    { name: "MergeConsecutiveGroups", value: location.MergeConsecutiveGroups },
    { name: "MaxProductsCount", value: location.MaxProductsCount },
    { name: "LayoutOrder", value: location.LayoutOrder },
    { name: "ClearEnabled", value: location.ClearEnabled },
    { name: "ClearRequiredUserRole", value: location.ClearRequiredUserRole },
    {
      name: "MaxProductsDisplayCount",
      value: location.MaxProductsDisplayCount,
    },
    { name: "IsEnable", value: location.IsEnable ? true : false },
  ];

  return await apiService.callV2("[BYI].[UpsertCatLocation]", parameters);
};

export const deleteLocation = async (locationId: number | null) => {
  const apiService = new MESApiService();

  const parameters: spParameter[] = [{ name: "LocationId", value: locationId }];

  return await apiService.callV2("[BYI].[DeleteCatLocation]", parameters);
};
